"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useMNetScript = _interopRequireDefault(require("./useMNetScript"));

var _useTrackingLayer = _interopRequireDefault(require("../utils/useTrackingLayer"));

var _MNetCss = _interopRequireDefault(require("./MNet.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MNet = function MNet(_ref) {
  var user = _ref.user,
      tracking = _ref.tracking,
      email = _ref.email;
  var sid = user.sid,
      eid = user.eid,
      hsid = user.hsid,
      page = user.page;
  var componentIsMounted = (0, _react.useRef)(true);
  (0, _useTrackingLayer.default)(tracking, email);
  (0, _useMNetScript.default)('//csearchclub-a.akamaihd.net/dsi.js?cid=8CU7INKUC');
  (0, _react.useEffect)(function () {
    if (componentIsMounted.current) {
      window.si_misc.query = page;
      window.si_chnm = "".concat(sid, "-").concat(eid);
      window.medianet_convTrack = {
        hsid: hsid
      };

      window._mNHandle.queue.push(function () {
        window._mNDetails.loadTag('857097420', '600x250', '857097420');
      });
    }

    ;
    return function () {
      componentIsMounted.current = false;
    }; // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "857097420",
    style: _MNetCss.default.main
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: _MNetCss.default.header
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: _MNetCss.default.text
  }, "Sponsored: "), /*#__PURE__*/_react.default.createElement("span", {
    style: _MNetCss.default.textLg
  }, "Explore the options below")));
};

var _default = (0, _radium.default)(MNet);

exports.default = _default;

//# sourceMappingURL=MNet.jsx.map